export enum Brand {
  Yandex = 'yandex',
  Yango = 'yango',
}
